/* __next_internal_client_entry_do_not_use__ HeaderCareers auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { TopOfPageContentWrapper } from "@faire/retailer-visitor-shared/components/App/TopOfPageContent/Wrapper";
import { HeaderCareersDesktop } from "@faire/retailer-visitor-shared/components/Header/desktop/HeaderCareersDesktop";
import { HeaderCareersMobile } from "@faire/retailer-visitor-shared/components/Header/mobile/HeaderCareersMobile";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import careersPath from "@faire/web-api--source/routes/careers";
import belongingPath from "@faire/web-api--source/routes/careers/belonging-at-faire";
import jobOpeningsPath from "@faire/web-api--source/routes/careers/openings";
import { observer } from "mobx-react";
import React from "react";
var HeaderCareersBase = function() {
    var isTabletAndBelow = useViewport().isTabletAndBelow;
    var pathList = usePathList();
    return /*#__PURE__*/ _jsx(TopOfPageContentWrapper, {
        children: isTabletAndBelow ? /*#__PURE__*/ _jsx(HeaderCareersMobile, {
            pathList: pathList
        }) : /*#__PURE__*/ _jsx(HeaderCareersDesktop, {})
    });
};
export var HeaderCareers = observer(HeaderCareersBase);
var usePathList = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    return [
        {
            path: careersPath(),
            label: strictLocalize({
                id: "kVS3QG",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Life at Faire"
                    }
                ]
            })
        },
        {
            path: belongingPath(),
            label: strictLocalize({
                id: "usVZBZ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Belonging at Faire"
                    }
                ]
            })
        },
        {
            path: jobOpeningsPath(),
            label: strictLocalize({
                id: "+l5Tmz",
                defaultMessage: [
                    {
                        type: 0,
                        value: "All Job Openings"
                    }
                ]
            })
        }
    ];
};
